import { useState } from 'react'

import { UserSlice } from 'features/user/forms/UserEmployeeForm/types'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { GET_EMPLOYEE, userFromDTO } from './api'
import { Data, Variables } from './api/types'
import { UseGetEmployeeProps, UseGetEmployeeType } from './types'

export const useGetEmployee = ({ id }: UseGetEmployeeProps): UseGetEmployeeType => {
  const [user, setUser] = useState<UserSlice>()

  if (id === undefined) {
    throw 'User ID is required to fetch'
  }

  const { isLoading } = useQuery<Variables, Data>({
    onCompleted: async data => {
      const { node } = data

      if (node) {
        setUser(userFromDTO(node))
      }
    },
    query: GET_EMPLOYEE,
    variables: { id },
  })

  return {
    loading: isLoading,
    user,
  }
}
